module.exports = __webpack_public_path__ + "img/8a4d4f5.jpg";